<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Corrective Action ' + action.corrective_action_id + ' :: MeritEHS'"/>

            <corrective-action-breadcrumbs :action="action" mode="View"></corrective-action-breadcrumbs>

            <div class="row">
                <div class="col-xl-8 col-lg-10">
                    <div class="card mb-4">
                        <div class="card-header">
                            Corrective Action: <strong>{{ action.corrective_action_id }}</strong>
                            <div class="float-md-right float-none mt-2 mt-md-0">
                                <router-link v-if="actionIsOpen" :to="`/corrective-actions/complete/${corrective_action_id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-check-square"></i> Mark Completed
                                </router-link>
                                <router-link :to="`/corrective-actions/edit/${corrective_action_id}`" class="btn btn-sm btn-light" v-if="canEdit">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <router-link :to="`/corrective-actions/delete/${corrective_action_id}`" class="btn btn-sm btn-light" v-if="canDelete">
                                    <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                                </router-link>
                                <a :href="emailLink" class="btn btn-sm btn-light">
                                    <i class="fa fa-envelope"></i> Email
                                </a>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-6 col-md-12 mb-md-2">
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Status:</div>
                                        <div class="col-md-8">
                                            <label :class="`badge badge-${action.status_id ? action.status_color : ''}`">
                                                {{ action.status_id ? action.status_name : '--' }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Created By:</div>
                                        <div class="col-md-8">
                                            <user-name :user="creator" v-if="action.creator_id" />
                                            <employee-name
                                                :employee="{EmployeeId: action.creator_employee_id, FirstName: action.creator_first_name, LastName: action.creator_last_name, EmployeeNumber: action.creator_employee_nbr}"
                                                v-else-if="action.creator_employee_id" />
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Assigned To:</div>
                                        <div class="col-md-8">
                                            <router-link v-if="$root.hasPermission('settings.view.users')" :to="`/users/view/${action.assignee_id}`" title="View User"><user-name :user="assignee" /></router-link>
                                            <span v-else><user-name :user="assignee" /></span>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3" v-if="action.other_assignees && action.other_assignees.length > 0">
                                        <div class="col text-muted">Other Assignees:</div>
                                        <div class="col-md-8">
                                            <span v-for="(assign, i) in action.other_assignees">
                                                <template v-if="i > 0">, </template><router-link :to="`/users/view/${assign.UserId}`" title="View User">{{ assign.FirstName }} {{ assign.LastName }}</router-link>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Completed By:</div>
                                        <div class="col-md-8">
                                            <user-name :user="completer" v-if="action.completed_by" />
                                            <employee-name
                                                :employee="{EmployeeId: action.completed_by_employee_id, FirstName: action.completer_first_name, LastName: action.completer_last_name, EmployeeNumber: action.completer_employee_nbr}"
                                                v-else-if="action.completed_by_employee_id" />
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3" v-if="action.subcontractor_id || action.subcontractor">
                                        <div class="col text-muted">Subcontractor:</div>
                                        <div class="col-md-8">
                                            <router-link :to="`/subcontractors/view/${action.subcontractor_id}`" v-if="action.subcontractor_id">{{ action.subcontractor_name }}</router-link>
                                            <span v-else-if="action.subcontractor">{{ action.subcontractor }}</span>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3" v-if="action.source_name">
                                        <div class="col text-muted">Source:</div>
                                        <div class="col-md-8">{{ action.source_name }}</div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-12">

                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Location:</div>
                                        <div class="col-md-8">{{ action.location }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Jobsite:</div>
                                        <div class="col-md-8">
                                            <router-link :to="`/jobsites/view/${action.JobsiteId}`" v-if="action.JobsiteId && $root.hasPermission('jobsites.view')">{{ action.JobsiteNumber }} - {{ action.JobsiteName }}</router-link>
                                            <span v-else>{{ action.JobsiteNumber }} - {{ action.JobsiteName }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <h6 class="card-header">
                            Details:
                        </h6>
                        <div class="card-body">
                            {{ action.detail }}
                        </div>
                    </div>
                    <div class="card mb-4">
                        <h6 class="card-header">
                            Completed Details
                        </h6>
                        <div class="card-body">
                            <template v-if="action.completed_detail">
                                {{ action.completed_detail }}
                            </template>
                            <template v-else>
                                -- No Completed Details --
                            </template>
                        </div>
                    </div>
                    <div class="card mb-4">
                        <h6 class="card-header">
                            Files &amp; Photos
                        </h6>
                        <div class="card-body">
                            <file-list :files="files" />
                        </div>
                    </div>
                </div>

                <div class="col-xl-4 col-lg-10 mt-xl-0 mt-4">
                    <div class="card mb-4">
                        <div class="card-header">
                            Timeline
                        </div>
                        <div class="card-body">
                            <div class="row mb-sm-2 mb-3">
                                <div class="col text-muted text-md-right">Created:</div>
                                <div class="col-md-8">{{ action.created_at | moment('timezone', userTimezone, 'MM/DD/YYYY hh:mm a') }}</div>
                            </div>
                            <div class="row mb-sm-2 mb-3">
                                <div class="col text-muted text-md-right">Due Date:</div>
                                <div class="col-md-8">
                                    <span v-if="action.due_date">{{ action.due_date | moment("MM/DD/YYYY")  }}</span>
                                </div>
                            </div>
                            <div class="row mb-sm-2 mb-3">
                                <div class="col text-muted text-md-right">Completed:</div>
                                <div class="col-md-8">{{ action.completed_at | moment('timezone', userTimezone, 'MM/DD/YYYY hh:mm a')  }}</div>
                            </div>
                            <div class="row mb-sm-2 mb-3">
                                <div class="col text-muted text-md-right">Time to Completion:</div>
                                <div class="col-md-8">{{ action.time_to_completion  }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                corrective_action_id: this.$route.params.id,
                action: {},
                files: [],
                userTimezone: this.$store.state.user.timezone,
                emailLink: '',
            }
        },

        computed: {
            assignee() {
                return {
                    UserId: this.action.assignee_id,
                    FirstName: this.action.assignee_first_name,
                    LastName: this.action.assignee_last_name,
                    deleted_at: this.action.assignee_deleted_at,
                    email: this.action.assignee_email,
                };
            },

            creator() {
                return {
                    UserId: this.action.creator_id,
                    FirstName: this.action.creator_first_name,
                    LastName: this.action.creator_last_name,
                    deleted_at: this.action.creator_deleted_at,
                    email: this.action.creator_email,
                };
            },

            completer() {
                return {
                    UserId: this.action.completed_by,
                    FirstName: this.action.completer_first_name,
                    LastName: this.action.completer_last_name,
                    deleted_at: this.action.completer_deleted_at,
                    email: this.action.completed_email,
                };
            },

            actionIsOpen(){
                if((this.action.status_context == 'Open' || this.action.status_context == 'InProgress'))
                {
                    //Check for attachment
                    if(this.attachedToAction || this.$root.hasPermission('correctiveActions.manage'))
                    {
                        return true;
                    }
                }

                //Send it
                return false;
            },

            attachedToAction(){
                //Check Assigneed
                if(this.action.assignee_id == this.$store.state.user.user_id || this.action.creator_id == this.$store.state.user.user_id)
                {
                    return true;
                }

                //Check Creator
                if(this.action.creator_id == this.$store.state.user.user_id)
                {
                    return true;
                }

                //Check others
                if(this.action.other_assignees && this.action.other_assignees.length > 0)
                {
                    //Loop
                    for(var i in this.action.other_assignees)
                    {
                        //Check ID
                        if(this.action.other_assignees[i].UserId == this.$store.state.user.user_id)
                        {
                            return true;
                        }
                    }
                }

                //Stop
                return false;
            },

            canEdit(){
                //Check Creator ID
                if(this.action.creator_id == this.$store.state.user.UserId)
                {
                    return true;
                }

                //Check Attachment and Permission
                if(this.attachedToAction && this.$root.hasPermission('correctiveActions.edit.assigned'))
                {
                    return true;
                }

                //Check Permission
                return this.$root.hasPermission('correctiveActions.manage');
            },

            canDelete(){
                //Check ID
                if(this.action.creator_id == this.$store.state.user.UserId)
                {
                    return true;
                }

                //Check Permission
                return this.$root.hasPermission('correctiveActions.manage');
            },
        },

        methods: {
            getCorrectiveAction: function() {
                //Get the data
                this.$http
                    .get('corrective-actions/view/' + this.corrective_action_id)
                    .then(response => {
                        //Set all the data
                        this.action = response.data.action;
                        this.files = response.data.files;
                        this.emailLink = response.data.emailLink;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

        },
        mounted() {
            //Get the action
            this.getCorrectiveAction();
        }
    }
</script>
